import { EMPTY, of } from 'rxjs'
import { delayWhen, filter, startWith, switchMap, take } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as R from 'ramda'
import { replace } from 'connected-react-router'
import moment from 'moment'
import { filtersCall } from 'api/planet/filters'
import { toHref } from 'helpers/PathHelper'
import * as Actions from 'store/actions/index.ts'
import { awaitForSaleFetched } from 'store/epics/helpers'
import {
  getBeginDate,
  getCountryCode,
  getCultureCode,
  getIsSaleFetched,
  getMarketId,
  getOperationCode,
  getQuery,
  getSaleKey,
  getShouldDoubleThePriceFeatureEnabled,
  getUri
} from 'store/selectors'

const initFiltersWithContextSelectionEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.member.MEMBER_INFO_FETCHED),
  take(1),
  delayWhen(() => {
    const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))

    return (getIsSaleFetched(state$.value))
      ? of({})
      : awaitForSaleFetched(resourceFetched$, state$)
  }),
  filter((action) => (
    action?.payload?.response?.selection !== undefined
  )),
  switchMap((action) => {
    const state = state$.value

    const beginDate = getBeginDate(state)
    const countryCode = getCountryCode(state)
    const cultureCode = getCultureCode(state)
    const marketId = getMarketId(state)
    const saleKey = getSaleKey(state)
    const operationCode = getOperationCode(state)
    const query = getQuery(state)
    const isResourceV2 = getShouldDoubleThePriceFeatureEnabled(state)
    const uri = getUri(state)

    const selection = action.payload.response.selection

    const departureCity = selection.departureCity
    const departureCities = departureCity !== undefined ? [departureCity] : []

    const duration = selection.nights
    const durations = duration !== undefined ? [duration] : []

    const today = moment()
    const checkin = selection.checkin
    const departureDates = []
    const departureDateOffsetWithFlexibility = []
    if (checkin !== undefined && moment(checkin).isAfter(today)) {
      const formattedCheckin = moment(checkin).format('YYYY/MM/DD')
      const formattedBeginDate = moment(beginDate).format('YYYY/MM/DD')
      const departeDateOffset = moment(formattedCheckin).startOf('day').diff(formattedBeginDate, 'days')
      departureDates.push(moment(checkin).format('DD/MM/YYYY'))
      departureDateOffsetWithFlexibility.push(departeDateOffset, 0)
    }

    const newQuery = {}
    if (departureCity !== undefined) {
      newQuery.departureCities = departureCity
    }
    if (duration !== undefined) {
      newQuery.durations = duration.toString()
    }
    if (checkin !== undefined && moment(checkin).isAfter(today)) {
      newQuery.departureDates = departureDateOffsetWithFlexibility.join(',')
    }

    const URL = toHref({
      pathname: uri,
      query: { ...(query.key && { key: query.key }), ...newQuery }
    }, query)

    if (R.isEmpty(newQuery)) {
      return EMPTY
    }

    return filtersCall(
      countryCode,
      cultureCode,
      departureCities,
      departureDates,
      durations,
      marketId,
      operationCode,
      saleKey,
      isResourceV2
    ).pipe(
      switchMap(({ response: { products } }) => (
        of(Actions.filters.onFiltersFetched(products))
      )),
      startWith(
        replace(URL),
        Actions.filters.onFiltersFetchStarted(),
        Actions.filters.onInitFilters(departureCities, departureDateOffsetWithFlexibility, durations, undefined)
      )
    )
  })
)

export default initFiltersWithContextSelectionEpic
